export { COOKIE_NAME, ONE_YEAR_MS } from "@shared/const";

/**
 * Where to send an unauthenticated user. With the local admin login,
 * everything happens on the /admin page itself.
 */
export const getLoginUrl = () => "/admin";
